import { sha256 } from "sha.js";
export const shaStr = (input) => new sha256().update(input).digest("hex");
//# sourceMappingURL=utils.js.map